import {
  MDBBtn,
  MDBDatatable,
  MDBIcon,
  MDBInput,
  MDBSpinner
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Tooltip } from "react-tooltip";
import { getMisc, getStreamsTeam } from "../../apiclients/streamsapi_bridge";
import PopupLoader from "../../views/popups/PopupLoader";
import AddSteamsTeam from "../../views/popups/users/AddSteamsTeam";
import RemoveStreamsTeam from "../../views/popups/users/RemoveStreamsTeam";
import Body from "../body/BodyPage";
import MainLinks from "../navlinks/MainLinks";
import PopupLoaderNew from "../../views/popups/PopupLoaderNew";
import { defaultUImg } from "../images";
import  { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch";
import UIConstant from "../../apiclients/UIConstant";
import { getStreamsProductName } from "../../apiclients/CommonUtils";
import TabIDConstant from "../../apiclients/TabIDConstant";
export default function StreamTeams(props) {
  /************************************************************************/
  const [streamteams, setStreamTeams] = useState([]);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(true);
  const [addTeam, setAddTeam] = useState(false);
  const togglePopup = () => setAddTeam(!addTeam);
  const [deleteTeam, setDeleteTeam] = useState(false);
  const dtogglePopup = () => setDeleteTeam(!deleteTeam);
  const [teamId, setTeamId] = useState("");
  const addStreamsTeamRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  const [searchValue, setsearchValue] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [rowdata, setRowData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);

  const streamsProductName = getStreamsProductName();
  function handleClick() {
    addStreamsTeamRef.current.click();
  }

  /*************************************************************************/
  function showThisInf(tdata) {

    console.log("Values is ::::::::::: " + JSON.stringify(tdata.team));
    navigate("/selectedteamsettings", {
      state: tdata.team,
    });
  }
  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
  const [sourceUsers, setSourceUsers] = useState([]);

  const handleAddTeam = () => {
    getTeamUsersInfo();
  }

  async function getTeamUsersInfo() {
    let UserList = [],
      apiResponse = {};
      setIsloading(true);
    apiResponse = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["team_members"], operation_type: "create" }
    );
    setIsloading(false);

    if (apiResponse.status === 200) {
      UserList = await apiResponse.json();

      UserList = UserList?.misc?.team_members ?? [];
      console.log(`Team Free UserList ::::: ${JSON.stringify(UserList)}`);
      setSourceUsers(UserList);
      togglePopup();
    } else {
    }
  }

  async function fetchData() {
    sessionStorage.setItem("current_link", "streamsteamssection");
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getStreamsTeam(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      TabIDConstant.STREAMS_TEAMS_LINK
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const rawData = await response.json();
    setTimeout(() => {
      setIsloading(false);
    }, 2000);
    if (!rawData) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("Response Data is ::::: " + JSON.stringify(rawData));
    setStreamTeams(rawData?.all_teams ?? []);
  }

  function deletethisTeam(evntData, teamid) {
    evntData.preventDefault();
    evntData.stopPropagation();

    console.log("event data:: ");
    console.log(evntData);
    setTeamId(teamid);
    dtogglePopup();
  }

  useEffect(() => {
  let proccessdRows = [];
  streamteams.map((team) => {
    let nArray = [];

    proccessdRows.push({
      team: team,
      user: (<>
        <img
          src={defaultUImg}
          alt=""
          style={{
            width: "45px",
            height: "45px",
          }}
          className="rounded-circle"
        />
      </>),
      team_name: team.team_name,
      team_type: team.team_type,
      delete: (
        <>
          {/* <a className="ms-4"
            style={{ zIndex: 99996 }}
            href="#"
            onClick={(e) => deletethisTeam(e, `${team.team_id}`)}
            target="_new"
          >
            <MDBIcon fas icon="times" color="primary" title="Remove" />
          </a> */}

          <div className="d-flex align-items-center justify-content-center">
            <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip" onClick={(e) => deletethisTeam(e, `${team.team_id}`)}>
              <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
            </div>
          </div>
        </>
      )
    });
  });
  setRowData(proccessdRows);
  setFilteredRows(proccessdRows)
  setDataLoaded(true)
}, [streamteams])


  const basicData = {
    columns: [{ label: "", field: "user", sort: false, colSpan: 2 },
    {
      label: "Name",
      field: "team_name",
      sort: true,
      colSpan: 1,
    },
    { label: "Type", field: "team_type" },
    { label: "Remove", field: "delete", sort: false },],
    rows: rowdata,
  };
  /********************************Fetching Display Data Starts Here!************************************************* */
  useEffect(() => {
    fetchData();
  }, []);

  /********************************************************************************* */

  const handleManualSearch = (searchValue) => {
    setsearchValue(searchValue);

    const filteredUsers = customSearch(rowdata, searchValue, UIConstant.STEAMS_TEAMS);

    setFilteredRows(filteredUsers);
};

  return (
    <React.Fragment>
      <>
        <MainLinks active={3} />
        <Body
          tablinks={3}
          sublink={15}
          content={
            <>
              <section className="mb-3">
                <div className="card card-height">
                  <div className="card-header py-3 px-0">
                    <h5 className="mb-0 ">
                      {t("StreamsTeams", {"PRODUCT_NAME" : streamsProductName})}
                    </h5>
                  </div>

                  {isloading && (
                    <>
                      <div className="loadingclass">
                        <MDBBtn disabled>
                          <MDBSpinner
                            size="sm"
                            role="status"
                            tag="span"
                            className="me-2"
                          />
                          Loading...
                        </MDBBtn>
                      </div>
                    </>
                  )}

                  <div className="card-body px-0">
                    {/* <div className="position-absolute left__341px">
                      <MDBBtn className="btn_adjust mt-2 ms-4">
                        <MDBIcon fas icon="filter" /> {t("addFilter")}
                      </MDBBtn>
                      <MDBBtn className="mx-2" >Clear</MDBBtn>
                    </div> */}
                    {/* <div className="actionbar"> */}
                    <div className="actionbar button_aligniment">

                      <div className="float-end d-flex align-items-center mt-2_responsive">



                        <MDBBtn className="btn_adjust me-3 mt-2" onClick={handleAddTeam}>
                          <MDBIcon fas icon="plus" size="sm" className="me-2" /> {t("AddTeam")}
                        </MDBBtn>

                      </div>
                    </div>
                    {/* </div> */}
                    <div className='mb-2 mt-2 position-relative w-auto'>
                      <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                      <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                    </div>
                    <div className="streamsteamssectionDatatable usersData-Table mt-0">
                      <MDBDatatable  key={searchValue} className="datatableSelect actioncolumn"
                        onRowClick={(event, rowData) => {
                          showThisInf(event);
                        }}
                        fixedHeader
                        entries={50}
                        multi
                        selectable
                        sortField="Name"
                        sortOrder="asc"
                        searchInputProps={[]}
                        data={{
                          ...basicData,
                          rows: filteredRows, // Use filtered rows here
                        }}
                        responsive
                        hover
                      />
                    </div>
                  </div>
                </div>
              </section>


              {addTeam && (
                <PopupLoaderNew
                  title={"Add Team"}
                  content={<AddSteamsTeam
                    onClose={togglePopup}
                    sourceUsers = {sourceUsers}
                    ref={addStreamsTeamRef}
                    setIsloading={setisLoading}
                  />}
                  onShow={setAddTeam}
                  onClose={togglePopup}
                  onSave={handleClick}
                  isloading={isLoading}
                  flag={1}
                />
              )}

              {deleteTeam && (
                <PopupLoaderNew
                  title={"Remove Team"}
                  content={<RemoveStreamsTeam
                    teamId={teamId}
                    onClose={dtogglePopup}
                    ref={addStreamsTeamRef}
                    setIsloading={setisLoading}
                  />}
                  onShow={setDeleteTeam}
                  onClose={dtogglePopup}
                  onSave={handleClick}
                  isloading={isLoading}
                  flag={4}
                />
              )}
            </>

          }
        />
        {/* <Footer /> */}

        <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
          Remove
        </Tooltip>
      </>
    </React.Fragment>
  );
}
